import { render, staticRenderFns } from "./BlockTitle.vue?vue&type=template&id=0c92438c"
import script from "./BlockTitle.vue?vue&type=script&lang=js"
export * from "./BlockTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports